export const cssVars = {
  contentMaxWidth: "--content-max-width",
  layoutMaxWidth: "--layout-max-width",
};
